import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"rules":_vm.rules,"items":_vm.locations,"label":_vm.label,"item-text":"name","item-value":"id"},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})
}
var staticRenderFns = []

export { render, staticRenderFns }